import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#e63946' },
    secondary: { main: '#2c3e50' }, 
    background: { default: '#f9f9f9', paper: '#FFFFFF' },
    text: { primary: '#2c3e50', secondary: '#6c757d' },
    success: { main: '#28a745' }, 
    error: { main: '#dc3545' },
  },
  typography: {
    fontFamily: '"Nunito Sans", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 700 },
    h2: { fontSize: '2rem', fontWeight: 700 },
    body1: { fontSize: '1rem', fontWeight: 400 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '12px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            backgroundColor: '#c9303d',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          borderRadius: 12,
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        backdrop: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
  },
});

export default theme;